import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilterButtonGroup from '../../components/Filter/FilterButtonGroup';
import { configFilter } from './SecureMessagesConfig';
import { toggleMessageThreadsFilter, threadMessagesRequested }
  from '../../redux/modules/secure-message/secure-message-middleware';
import { secureMessageThreadClear } from '../../redux/modules/secure-message/actions/creators';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

class SecureMessagesFilter extends Component {
  handleClickEvent = (filterValue) => {
    if (!filterValue || filterValue.length === 0) {
      return;
    }
    this.props.dispatch(MsgBarActions.dismissMessage());
    const { dispatch, language, timeZone, timeZoneOffset, selectedThreadIndex,
      selectedArchivedThreadIndex, threads, patientId }
    = this.props;

    dispatch(toggleMessageThreadsFilter(filterValue));

    const threadId = filterValue === 'Current' ? selectedThreadIndex : selectedArchivedThreadIndex;
    const selectedThread = threads.find((x) => x.threadId === threadId);
    if (threadId !== null && threadId !== undefined) {
      dispatch(threadMessagesRequested(
        patientId, selectedThread.threadId, language, timeZone, timeZoneOffset));
    } else {
      dispatch(secureMessageThreadClear());
    }
  }

  render() {
    return (
        <FilterButtonGroup
          handleClickEvent={ this.handleClickEvent }
          { ...configFilter(this.props.filter) }
        />
    );
  }
}

SecureMessagesFilter.propTypes = {
  dispatch: PropTypes.func,
  filter: PropTypes.string,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  language: PropTypes.string,
  selectedThreadIndex: PropTypes.string,
  selectedArchivedThreadIndex: PropTypes.string,
  threads: PropTypes.array,
  patientId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  filter: state.secureMessage.filter,
  patientId: state.profile.patient.patientId,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  selectedArchivedThreadIndex: state.secureMessage.selectedArchivedThreadIndex,
  threads: state.secureMessage.threads,
});

export default connect(mapStateToProps)(SecureMessagesFilter);